import { render } from "./CloneQA.vue?vue&type=template&id=9494960c"
import script from "./CloneQA.vue?vue&type=script&lang=js"
export * from "./CloneQA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__